import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import CountrySelectComponent from 'src/modules/commons/inputs/country-select/CountrySelect.component';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

interface AddressFormComponentProps {
  formData: PhysicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
}

class AddressFormComponent extends React.PureComponent<AddressFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question46"
        >
          <div className="icon-title">
            <img
              alt="Euro"
              className="icon"
              src="/img/location.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Dirección habitual
              </strong>
              <span className="d-arrow-up" /></h4>
            <div className="gap-20" />
          </div>
        </div>
        <div
          id="question46"
          className="collapse"
        >
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Dirección"
                  value={this.props.formData.address || ''}
                  type="text"
                  required={true}
                  onChange={(value) => this.props.handleChange('address')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Piso, escalera, puerta"
                  value={this.props.formData.houseNumber || ''}
                  type="text"
                  required={false}
                  onChange={(value) => this.props.handleChange('houseNumber')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Código postal"
                  value={this.props.formData.zipCode || ''}
                  type="text"
                  required={true}
                  onChange={(value) => this.props.handleChange('zipCode')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Ciudad"
                  value={this.props.formData.city || ''}
                  type="text"
                  required={true}
                  onChange={(value) => this.props.handleChange('city')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Provincia"
                  value={this.props.formData.province || ''}
                  type="text"
                  required={true}
                  onChange={(value) => this.props.handleChange('province')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <CountrySelectComponent
                value={this.props.formData.country}
                required={true}
                onChange={this.props.handleChange('country')}
              />
              <div className="gap-20" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AddressFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/AddressForm.component.tsx